var _mask, _rect, _mask2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_902_25",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.759014,
    y: 0.55,
    width: 14,
    height: 6,
    rx: 1.2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.759014,
    y: 0.55,
    width: 14,
    height: 6,
    rx: 1.2,
    stroke: "currentColor",
    strokeWidth: 3.4,
    mask: "url(#path-1-inside-1_902_25)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_902_25",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.759014,
    y: 7.45,
    width: 14,
    height: 6,
    rx: 1.2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.759014,
    y: 7.45,
    width: 14,
    height: 6,
    rx: 1.2,
    stroke: "currentColor",
    strokeWidth: 3.4,
    mask: "url(#path-2-inside-2_902_25)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListGroup);
export default __webpack_public_path__ + "static/media/list-group.14516b4d.svg";
export { ForwardRef as ReactComponent };